import {ChatMessage} from './chat-message.model';

export class MessageRecipient {
  id?: string;
  recipientId: number;
  channelId: string;
  patientUserId: number;
  isRead: boolean;
  isForwarded: boolean;
  isFavorite: boolean;
  forwardedBy?: number;
  messageId: string;
  message?: ChatMessage;
  messageBody?: string;
  messageBodyShort?: string;
  messageTitle?: string;
  createdOn?: Date;
  modifiedOn?: Date;
}
